import "select2/dist/js/select2.full.js";
import "select2/dist/css/select2.css";

import "./extras.css";
import "./spin.jquery.js";
// import "./cocoon.js";

import Rails from "rails-ujs";

(function($) {
  $(document).ready(function() {
    $(".breadcrumb a").each(function() {
      var replacements = {
        "/admin/base_pages/1": "*",
        "/admin/base_pages/2": "About",
        "/admin/base_pages/3": "Contact Us",
        "/admin/base_pages/4": "Cookies",
        "/admin/base_pages/5": "Equipment",
        "/admin/base_pages/6": "Agitators and static mixers",
        "/admin/base_pages/7": "Turbo blowers and turbo compressors",
        "/admin/base_pages/8": "Sludge dewatering and microfiltration",
        "/admin/base_pages/9": "Vacuum filtration equipment",
        "/admin/base_pages/10": "Chemical and process pumps",
        "/admin/base_pages/11": "Home",
        "/admin/base_pages/12": "Legal",
        "/admin/base_pages/13": "Page not found",
        "/admin/base_pages/14": "Privacy",
        "/admin/base_pages/15": "Blog"
      };
      var r = replacements[$(this).attr('href')];
      if (typeof r !== 'undefined') {
        $(this).text(r);
      }
    });

    $(
      "#index_table_gallery_slides tbody"
    ).sortable({
      update: function(event, ui) {
        $("table").spin("large");

        var ids = [];

        $(this)
          .find("tr")
          .each(function() {
            ids.push(
              $(this)
                .attr("id")
                .replace(/\D+/, "")
            );
          });

        Rails.ajax({
          type: "POST", 
          url: window.location.pathname + "/sort",
          data: $.param({ids: ids}),
          success: function(repsonse){
            $("table").spin(false);
          },
        })
      }
    });

    $(".simple_form select.select2, .filter_form select").select2();
    $(".simple_form .select2-tags").select2({
      tags: true,
      tokenSeparators: [","]
    });
  });
})(jQuery);
